export const PRODUCT_STATUSES = {
  PROVIDED: 103,
  EXECUTION_EXPECTED: 102,
  PAYMENT_EXPECTED: 101,
  CANCELLED: 5,
  PENDING: 4,
  CLOSED: 3,
  BLOCKED: 2,
  ACTIVE: 1,
} as const;
